var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserapproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_12102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 14.375C17.7501 14.375 20.0001 12.125 20.0001 9.375C20.0001 6.625 17.7501 4.375 15.0001 4.375C12.2501 4.375 10.0001 6.625 10.0001 9.375C10.0001 12.125 12.2501 14.375 15.0001 14.375ZM29.6251 11.375C29.1251 10.875 28.3751 10.875 27.8751 11.375L25.3751 13.875L24.6251 13.125C24.1251 12.625 23.3751 12.625 22.8751 13.125C22.3751 13.625 22.3751 14.375 22.8751 14.875L24.5001 16.5C25.0001 17 25.7501 17 26.2501 16.5L29.6251 13.125C30.1251 12.625 30.1251 11.875 29.6251 11.375ZM15.0001 16.25C10.3751 16.25 6.37512 19.625 5.75012 24.25C5.62512 24.875 6.12512 25.625 6.87512 25.625H7.00012H23.0001C23.7501 25.625 24.2501 25.125 24.2501 24.375V24.25C23.6251 19.625 19.6251 16.25 15.0001 16.25Z",
    fill: "#38369C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_12102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserapproval);
export default __webpack_public_path__ + "static/media/userapproval.9e92871a92cd22f7d3027f92e9676732.svg";
export { ForwardRef as ReactComponent };